import React from 'react';
import { useStyles } from './PopupLoaderUseStyles';

const PopupLoader = () => {
  const classes = useStyles();
  const c = classes.PopupLoader;

  return (
    <div className={`${c}__overlay`}>
      <div className={`${c}__spinner`}>
        <div className={`${c}__glow`} />
        <div className={`${c}__ring ${c}__ring--1`} />
        <div className={`${c}__ring ${c}__ring--2`} />
        <div className={`${c}__ring ${c}__ring--3`} />
        <div className={`${c}__radar`} />
        <div className={`${c}__center-dot`} />
      </div>
      <div className={`${c}__label`}>
        Loading
        <span className={`${c}__dots`}>
          <span />
          <span />
          <span />
        </span>
      </div>
    </div>
  );
};

export default PopupLoader;
